export enum Paths {
  LOGIN = '/admin/login',
  DASHBOARD = '/admin',
  PROJECTS = '/admin/projects',
  ORGANIZERS = '/admin/organizers',
  TOPICS = '/admin/topics',
  EXPENDITURES = '/admin/expenditures',
  ENGAGEMENTS = '/admin/engagements',
  ACTIVITIES = '/admin/activities',
  LANGUAGES = '/admin/languages',
  PARTNERS = '/admin/partners',
  FOOTER = '/admin/footer',
  MENU = '/admin/menu',
  PAGES = '/admin/pages',
  PROJECTS_CSV = '/admin/projects-csv',
  FIRST_TASK = '/admin/user',
  USERS = '/admin/all-user',
  ADD_TASK = '/admin/user-details',
  EDIT_PROFILE = '/admin/user-profile',
  NEW_PASSWORD = '/admin/login/resetpassword',
  BENEFITS = '/admin/benefits',
  ANFRAGEN = '/admin/anfragen',
  BADGE = '/admin/badge',
}
